<button
  type="button"
  class="copy-url-btn"
  [disabled]="isDisabled"
  [title]="isDisabled ? 'Preencha a URL para copiar' : prefix + (slug ?? '')"
  (click)="copy()"
>
  <lib-elux-icon color="#fff" [icon]="'Copy.svg'" size="16" sizeType="px" />
  <span>copiar</span>
</button>
